/**
 * What the user chose to do with an existing journal entry when marking a payable as paid by
 * matching it (SD-8207). Mirrors core's App\Constants\Payable\JournalEntryMatchAction.
 */
export enum JournalEntryMatchAction {
    KEEP = 'keep',
    REPLACE = 'replace',
}

/**
 * One ledger line of the entry that represents a payable's payment. Amounts are in cents.
 */
export interface PaymentEntryLine {
    accountName: string;
    debit: number;
    credit: number;
}

/**
 * A payable payment matched to a journal entry (SD-9004): which entry, whether it was kept or
 * replaced with PayHOA's standard payment entry, and the ledger lines now representing the payment —
 * the journal entry's own lines when kept, the standard entry's lines when replaced.
 */
export class PayableJournalEntryMatch {
    action: JournalEntryMatchAction;
    journalEntryId: number;
    paymentEntryLines: PaymentEntryLine[] = [];

    constructor(match: any) {
        this.action = match?.action === JournalEntryMatchAction.REPLACE
            ? JournalEntryMatchAction.REPLACE
            : JournalEntryMatchAction.KEEP;
        this.journalEntryId = match?.journalEntryId || 0;
        this.paymentEntryLines = (match?.paymentEntryLines || []).map((line: any) => ({
            accountName: line.accountName || '',
            debit: line.debit || 0,
            credit: line.credit || 0,
        }));
    }

    /** "Journal Entry #1042" — the matched entry's display name, shared by every payable view. */
    get journalEntryLabel(): string {
        return `Journal Entry #${this.journalEntryId}`;
    }

    get isKept(): boolean {
        return this.action === JournalEntryMatchAction.KEEP;
    }

    get isReplaced(): boolean {
        return this.action === JournalEntryMatchAction.REPLACE;
    }
}
